var partnerAttributionResize = function () {
    if (partnerAttributionResizeWrap)
        $(".partnerAttributionDesc.wrap").width($("#divPartnerInfo").width() - $(".partnerAttributionLogo").width() - 14);
    if (($(".partnerAttributionImage").width() + 8 > $("#divPartnerInfo").width() / 2) == partnerAttributionResizeWrap) {
        if (partnerAttributionResizeWrap) {
            $(".partnerAttributionDesc.wrap").addClass("nowrap").removeClass("wrap");
            $(".partnerAttributionDesc.nowrap").css("width", "");
            partnerAttributionResizeWrap = false;
        } else {
            $(".partnerAttributionDesc.nowrap").addClass("wrap").removeClass("nowrap");
            $(".partnerAttributionDesc.wrap").width($("#divPartnerInfo").width() - $(".partnerAttributionLogo").width() - 14);
            partnerAttributionResizeWrap = true;
        }
    }

    if ($(".partnerAttributionDesc.wrap").length) {
        $(".partnerAttributionLogo").css("padding-top", "5px");
    }
}

var partnerAttributionImageSrc = $("<img />").attr('src', $(".partnerAttributionImage").attr('src'));
if (partnerAttributionImageSrc)
    partnerAttributionImageSrc.on('load', partnerAttributionResize);
$(window).resize(partnerAttributionResize);
var partnerAttributionResizeWrap = false;